import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCarouselControls } from '../../hooks/useCarouselControls.js';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { renderDefaultFoldButton } from '../../ui-kit/Foldable/DefaultFoldButton.js';
import { Foldable } from '../../ui-kit/Foldable/Foldable.js';
import { FoldableSection } from '../../ui-kit/Foldable/FoldableSection.js';
import { style } from '../../utils/style.js';
import { Headline } from '../Headline/Headline.js';
import { COLS_LENGTH_FOR_SCROLL } from './constants.js';
import { TariffsTableRow } from './TariffsTableRow.js';
import { TariffsTableWrapper } from './TariffsTableWrapper.js';
export const TariffsTable = JSX(({ className = '', title, description, rowHeaders, tariffsColumns: columns, hiddenRowsNum = 0, ...rest }) => {
    const colData = columns?.map(({ data }) => data) || [];
    const rowData = rowHeaders?.map((header, i) => ({
        header,
        data: colData.map((col) => col?.[i] || []),
    }));
    const itemCount = colData.length;
    const [activeIndex, controls] = useCarouselControls({
        itemCount: itemCount,
        visibleItemCount: COLS_LENGTH_FOR_SCROLL,
    });
    const rows = (rowData || []).map((row, i) => (_jsx(TariffsTableRow, { row: row, activeIndex: activeIndex, rowIdx: i, ...rest }, String(i))));
    const [visibleRows, hiddenRows] = hiddenRowsNum > 0 ? [rows.slice(0, -hiddenRowsNum), rows.slice(-hiddenRowsNum)] : [rows, []];
    return (_jsxs(BlockWrapper, { className: style('relative space-y-6xl @4xl:space-y-xl', className), defaultPadding: "p-6xl", ...rest, children: [_jsx(Headline, { title: title, description: description, headlineVersion: "M", isEmbedded: true, align: "text-center" }), _jsx("div", { className: "space-y-m overflow-hidden", children: hiddenRowsNum > 0 ? (_jsx(Foldable, { renderFoldableSection: ({ isUnfolded }) => (_jsxs(TariffsTableWrapper, { controls: controls, children: [visibleRows, _jsx(FoldableSection, { isUnfolded: isUnfolded, children: hiddenRows })] })), renderFoldButton: renderDefaultFoldButton })) : (_jsx(TariffsTableWrapper, { controls: controls, children: rows })) })] }));
});
//# sourceMappingURL=TariffsTable.js.map